<template>
  <canvas class="v-fade-out-in" ref="canvas"></canvas>
</template>

<script>
import debounce from "debounce";
import { timeout } from "@/utils/util";

let img_cover = function(
  contentWidth,
  contentHeight,
  containerWidth,
  containerHeight,
  offsetLeft,
  offsetTop
) {
  let contentRatio = contentWidth / contentHeight;
  let containerRatio = containerWidth / containerHeight;
  let resultHeight;
  let resultWidth;
  offsetLeft = typeof offsetLeft === "undefined" ? 0.5 : offsetLeft;
  offsetTop = typeof offsetTop === "undefined" ? 0.5 : offsetTop;
  if (contentRatio > containerRatio) {
    resultHeight = containerHeight;
    resultWidth = containerHeight * contentRatio;
  } else {
    resultWidth = containerWidth;
    resultHeight = containerWidth / contentRatio;
  }
  return {
    width: resultWidth,
    height: resultHeight,
    offsetLeft: (containerWidth - resultWidth) * offsetLeft,
    offsetTop: (containerHeight - resultHeight) * offsetTop,
  };
};

export default {
  name: "v-fade-out-in",
  props: {
    img: {
      type: String,
      required: true,
    },
    topArea: {
      type: Number,
      default: 0,
      description: "羽化距离顶部的位置, 0~1",
    },
    botArea: {
      type: Number,
      defaults: 0,
      description: "羽化距离底部的位置, 0~1",
    },
  },
  data() {
    return {
      imgObj: null,
    };
  },
  created() {
    this.drawCanvas = debounce(() => this.imgObj && this.draw(), 300);
  },
  mounted() {
    window.addEventListener("resize", this.drawCanvas);

    //   加载图片
    this.imgObj = new Image();
    this.imgObj.addEventListener("load", (ev) => this.canvas_init());
    this.imgObj.src = this.img;

    $(this.$el).css({ opacity: 0 });
    $(window).on("outAnimateEnded", () => {
      timeout().then(() => $(this.$el).css({ opacity: 1 }));
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.drawCanvas);
    $(window).off("outAnimateEnded");
  },
  methods: {
    canvas_init() {
      this.ctx = this.$refs.canvas.getContext("2d");
      this.draw();
    },
    get_gradient() {
      this.gradient = this.ctx.createLinearGradient(
        0,
        0,
        0,
        window.innerHeight
      );

      //  2020年1月28日 去掉羽化
      let topArea = this.topArea ? this.topArea : 0;
      let botArea = this.botArea ? this.botArea : 0;
      let topStart = topArea === 0 ? 0.068 : this.topArea;
      let bottomStart = botArea === 0 ? 0.938 : this.botArea;

      //  https://codepen.io/Buff_/pen/GRRyWOg?editors=0010
      this.gradient.addColorStop(0, "rgba(0,0,0,1)");
      this.gradient.addColorStop(topStart, "rgba(0,0,0,1)");
      this.gradient.addColorStop(topStart, "rgba(0,0,0,0)");
      this.gradient.addColorStop(bottomStart, "rgba(0,0,0,0)");
      this.gradient.addColorStop(bottomStart, "rgba(0,0,0,1)");
      this.gradient.addColorStop(1, "rgba(0,0,0,1)");
    },
    draw() {
      $(this.$refs.canvas).hide();
      this.get_gradient();
      this.calc_canvas_size();
      let imgRect = img_cover(
        this.imgObj.width,
        this.imgObj.height,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );

      this.ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      this.ctx.globalCompositeOperation = "source-over";
      this.ctx.fillStyle = this.gradient;
      this.ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);
      this.ctx.globalCompositeOperation = "source-in";

      this.ctx.drawImage(
        this.imgObj,
        imgRect.offsetLeft,
        imgRect.offsetTop,
        imgRect.width,
        imgRect.height
      );
      $(this.$refs.canvas).velocity("fadeIn", { duration: 100 });
    },

    calc_canvas_size() {
      this.$refs.canvas.width = window.innerWidth;
      this.$refs.canvas.height = window.innerHeight;
    },
  },
};
</script>

<style lang="scss">
.v-fade-out-in {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  pointer-events: none;
  transform: translateZ(0);
}

body.rtl {
  .v-fade-out-in {
    right: 0;
    left: auto;
  }
}
</style>
